import { Controller } from "@hotwired/stimulus"

// 決定者リストを進行中 / 完了に変更する際に、 名前を入力する <dialog> モーダルを開く。
// 「進行中にする」 / 「完了リストにする」 ボタンの click から openForStartProgress / openForFinalize
// が呼ばれ、 form の action とタイトル、 デフォルトの名前 ( 今日の日付 ) をセットしてモーダルを開く。
export default class extends Controller {
  static targets = ["dialog", "form", "title", "description", "input", "submit"]
  static values = {
    startProgressUrl: String,
    finalizeUrl: String,
    defaultName: String
  }

  openForStartProgress(event) {
    event.preventDefault()
    this.titleTarget.textContent = "進行中にする"
    this.descriptionTarget.textContent = "この予定リストを進行中ステータスに変更します。 リスト名を入力してください。"
    this.submitTarget.textContent = "進行中にする"
    this.submitTarget.className = "rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-amber-400 transition-colors cursor-pointer"
    this.formTarget.action = this.startProgressUrlValue
    this.openWithDefaultName()
  }

  openForFinalize(event) {
    event.preventDefault()
    this.titleTarget.textContent = "完了リストにする"
    this.descriptionTarget.textContent = "確定対象者のみで完了リストを作成します。 リスト名を入力してください。"
    this.submitTarget.textContent = "完了リストにする"
    this.submitTarget.className = "rounded-lg bg-green-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 transition-colors cursor-pointer"
    this.formTarget.action = this.finalizeUrlValue
    this.openWithDefaultName()
  }

  openWithDefaultName() {
    this.inputTarget.value = this.defaultNameValue
    if (this.dialogTarget.open) this.dialogTarget.close()
    this.dialogTarget.showModal()
    requestAnimationFrame(() => {
      this.inputTarget.focus()
      this.inputTarget.select()
    })
  }

  cancel(event) {
    event.preventDefault()
    this.dialogTarget.close()
  }
}
